/**
 * Adressökning mot Mapbox — samma sökning i admin (utdelarregistret) och på den öppna
 * uppdragslänken där utdelare lägger till sig själva. Koordinaterna följer med så att
 * hemmapricken hamnar rätt utan att någon behöver leta upp adressen på kartan efteråt.
 */
export interface GeocodeSuggestion {
    id: string;
    place_name: string;
    center: [number, number];
}

/** Tomt svar när frågan är för kort eller Mapbox inte svarar — sökningen får aldrig fälla formuläret. */
export const searchAddress = async (query: string, token: string): Promise<GeocodeSuggestion[]> => {
    if (!query || query.length < 3 || !token) return [];
    const url = `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(query)}.json?country=se&types=address&limit=5&access_token=${token}`;
    try {
        const res = await fetch(url);
        if (!res.ok) return [];
        const data = await res.json();
        return (data.features ?? []).map((f: any) => ({
            id: f.id,
            place_name: f.place_name,
            center: f.center as [number, number]
        }));
    } catch {
        return [];
    }
};
